module.exports = __webpack_public_path__ + "static/media/fcd-logo-orange.884f4e73.svg";